import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

// Wire our shared `history` instance as the router's navigator so that both
// useNavigate() and imperative history.push() drive the same history (stable v6:
// BrowserRouter ignores a custom navigator, HistoryRouter honors it).
export default function Router({ history, ...props }) {
  return <HistoryRouter history={history} {...props} />;
}
